module.exports = __webpack_public_path__ + "img/文化娱乐.7821446a.png";